import { USER_EMAIL_PATTERN } from '@movo/contracts/domain/user';

export type LoginForm = { email: string; password: string; rememberMe: boolean };

export type LoginErrors = { email?: string; password?: string };

/** Gli errori per campo del login; vuoto se si può inviare. */
export function loginErrors({ email, password }: Pick<LoginForm, 'email' | 'password'>) {
  const errors: LoginErrors = {};
  if (!email.trim()) errors.email = 'Inserisci email o username';
  if (!password) errors.password = 'Inserisci la password';
  return errors;
}

/** L'errore dell'email per il link di reset; `undefined` se va bene. */
export const forgotPasswordError = (email: string) =>
  USER_EMAIL_PATTERN.test(email.trim()) ? undefined : 'Inserisci un indirizzo email valido';
